import { render, staticRenderFns } from "./FindWordsImage.vue?vue&type=template&id=c24c6c42&scoped=true"
import script from "./FindWordsImage.vue?vue&type=script&lang=ts"
export * from "./FindWordsImage.vue?vue&type=script&lang=ts"
import style0 from "./FindWordsImage.vue?vue&type=style&index=0&id=c24c6c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c6c42",
  null
  
)

export default component.exports